import { useEffect, useState } from "react";
import { BTScannerWrapper } from "./BTScanner.styled";
import { Divider, message } from "antd";
import { BsUpcScan } from "react-icons/bs";
import { IoArrowDownSharp } from "react-icons/io5";
import BarcodeScanner from "../BarcodeScanner/BarcodeScanner";
import { BIN_SCAN_TYPES } from "../../constants";

const BTSComponent = ({
  currBarcode,
  newBarcode,
  validateScan1,
  validateScan2,
  setShowScanner,
  setCurrType,
  packagingType,
  showScanner,
  submitScan,
  history,
}) => {
  return (
    <>
      <BTScannerWrapper>
        <div className="barcodeValues">
          <p>
            Checked Container :{" "}
            <span className={!currBarcode ? "disable" : ""}>
              {currBarcode ? currBarcode : "N/A"}
            </span>
          </p>

          <p>
            New Container :{" "}
            <span className={!newBarcode ? "disable" : ""}>
              {newBarcode ? newBarcode : "N/A"}

              {validateScan2 && newBarcode !== validateScan2 ? (
                <span className="suggBox">
                  Suggested - <b>{validateScan2}</b>
                </span>
              ) : null}
            </span>
          </p>
        </div>

        <Divider>Scan</Divider>

        <button
          className="bbtn"
          onClick={() => {
            setShowScanner(true);
            setCurrType(BIN_SCAN_TYPES.SOURCE_SCAN);
          }}
          disabled={validateScan1 && validateScan1 === currBarcode}
        >
          <BsUpcScan /> Scan Checked Container
        </button>
        <IoArrowDownSharp className="toMark" />

        <button
          className="bbtn"
          disabled={!currBarcode}
          onClick={() => {
            setShowScanner(true);
            setCurrType(BIN_SCAN_TYPES.DESTINATION_SCAN);
          }}
        >
          <BsUpcScan /> Scan New Container
        </button>
      </BTScannerWrapper>

      {showScanner ? (
        <BarcodeScanner
          scan={showScanner}
          camera={showScanner}
          history={history}
          redirect="multi_scan"
          closable
          isRackSearch
          confirmCall={submitScan}
          getBoxId={() => setShowScanner(false)}
        />
      ) : null}
    </>
  );
};

export const BinTransferScanner = ({
  onSubmit,
  validateScan1 = "",
  validateScan2 = "",
  actionOnFirstScan = () => {},
  packagingType = "",
  allowSame = false,
  clearScanner,
  history,
}) => {
  const [currBarcode, setCurrBarcode] = useState(null);
  const [newBarcode, setNewBarcode] = useState(null);
  const [showScanner, setShowScanner] = useState(false);
  const [currType, setCurrType] = useState(null);

  useEffect(() => {
    if (validateScan1) setCurrBarcode(validateScan1);
  }, [validateScan1]);

  useEffect(() => {
    if (clearScanner && (currBarcode || newBarcode)) {
      if (clearScanner === BIN_SCAN_TYPES.SOURCE_SCAN) {
        setCurrBarcode(null);
      }
      if (clearScanner === BIN_SCAN_TYPES.DESTINATION_SCAN) {
        setNewBarcode(null);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clearScanner, currBarcode, newBarcode]);

  const submitScan = (result) => {
    if (currType) {
      setShowScanner(false);
      if (currType === BIN_SCAN_TYPES.SOURCE_SCAN) {
        if (validateScan1?.length && result !== validateScan1) {
          message.error(`Please scan ${validateScan1} for current container`);
          setCurrBarcode(null);
          return;
        } else {
          setCurrBarcode(result?.trim());
          actionOnFirstScan(result?.trim());
        }
      } else if (currType === BIN_SCAN_TYPES.DESTINATION_SCAN) {
        if (currBarcode === result && !allowSame) {
          message.error("Please scan different barcode!");
          return;
        }
        if (validateScan2?.length && result !== validateScan2) {
          message.error(`Please scan ${validateScan2} for current container`);
          setNewBarcode(null);
          return;
        }
        setNewBarcode(result?.trim());
        onSubmit(
          currBarcode?.trim(),
          result?.trim(),
          setNewBarcode,
          setCurrBarcode
        );
      }
    }
  };

  return (
    <>
      <BTSComponent
        {...{
          currBarcode,
          newBarcode,
          validateScan1,
          validateScan2,
          setShowScanner,
          setCurrType,
          packagingType,
          showScanner,
          submitScan,
          history,
        }}
      />
    </>
  );
};

export default BinTransferScanner;
